import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

export default class PasswordResetForm extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    passwordResetFunction: PropTypes.func.isRequired,
    securityToken: PropTypes.string,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    securityToken: null,
  };

  renderPasswordForm = () => {
    const { passwordResetFunction, submitting, handleSubmit, invalid } = this.props;
    return (
      <Form id="loginForm" onSubmit={handleSubmit(passwordResetFunction.bind(this))}>
        <fieldset>
          <Field
            name="password"
            type="password"
            component={InputField}
            label="Password"
            placeholder="your password"
            autoFocus
          />
          <Field
            name="confirmPassword"
            type="password"
            component={InputField}
            label="Confirm Password"
            placeholder="your password"
          />
        </fieldset>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={checkButtonDisabled(invalid, submitting)}
        >
          Set Password
        </button>
      </Form>
    );
  };

  renderNoTokenMessage = () => (
    <div className="alert alert-danger">
      <p>
        No security token found. This could be due to a malformed URI. Please contact your Datarista
        Admin to report this message.
      </p>
    </div>
  );

  render() {
    const { securityToken } = this.props;

    if (securityToken) {
      return this.renderPasswordForm();
    }
    return this.renderNoTokenMessage();
  }
}
